type MetaGroups = 'group1' | 'group2' | 'group3' | 'group4' | 'group5';

const movies: Record<string, MetaGroups> = {
	'/au/movie/tina-2025': 'group1',
	'/au/movie/pideme-lo-que-quieras': 'group1',
	'/au/movie/total-dhamaal': 'group1',
	'/au/movie/hidden-2021': 'group1',
	'/au/movie/untitled-dreamworks-animation-film-2024': 'group1',
	'/au/movie/silent-zone': 'group1',
	'/au/movie/lethal-seduction': 'group1',
	'/au/movie/asees': 'group1',
	'/au/movie/anjaam-pathiraa': 'group1',
	'/au/movie/erotic-ghost-story': 'group1',
	'/au/movie/yparho': 'group1',
	'/au/movie/the-ghazi-attack': 'group1',
	'/au/movie/no-other-land': 'group1',
	'/au/movie/free': 'group1',
	'/au/movie/glorious': 'group1',
	'/uk/movie/mickey-17': 'group1',
	'/uk/movie/pourquoi-jai-pas-mange-mon-pere': 'group1',
	'/uk/movie/the-salt-path': 'group1',
	'/uk/movie/below-her-mouth': 'group1',
	'/uk/movie/spermageddon': 'group1',
	'/uk/movie/my-fault-london': 'group1',
	'/uk/movie/illegal': 'group1',
	'/uk/movie/kraven-the-hunter': 'group1',
	'/uk/movie/mi-vida-loca': 'group1',
	'/uk/movie/virgin-territory': 'group1',
	'/uk/movie/untitled-dreamworks-animation-film-2024': 'group1',
	'/uk/movie/dawn-of-impressionism-paris-1874': 'group1',
	'/uk/movie/g-i-jane': 'group1',
	'/uk/movie/peter-kay-the-tour-that-didnt-tour-tour': 'group1',
	'/uk/movie/juror-2': 'group1',
	'/uk/movie/matilda-2022': 'group1',
	'/uk/movie/eden-2024': 'group1',
	'/uk/movie/the-hobbit-an-unexpected-journey': 'group1',
	'/uk/movie/perfume-the-story-of-a-murderer': 'group1',
	'/us/movie/no-other-land': 'group1',
	'/us/movie/young-hearts': 'group1',
	'/us/movie/novocaine-2025': 'group1',
	'/us/movie/downloaded': 'group1',
	'/us/movie/untitled-dreamworks-animation-film-2024': 'group1',
	'/us/movie/3-strikes': 'group1',
	'/us/movie/flow-2024': 'group1',
	'/us/movie/back-to-the-future-part-i': 'group1',
	'/us/movie/a-serbian-film': 'group1',
	'/us/movie/9-songs': 'group1',
	'/us/movie/the-brutalist': 'group1',
	'/us/movie/mittran-da-chaleya-truck-ni': 'group1',
	'/us/movie/the-town': 'group1',
	'/us/movie/den-of-thieves-2': 'group1',
	'/us/movie/revenge-of-the-nerds': 'group1',
	'/us/movie/chicuarotes': 'group1',
	'/us/movie/austin-powers-international-man-of-mystery': 'group1',
	'/us/movie/let-me-be-with-you': 'group1',
	'/us/movie/misericorde': 'group1',
	'/us/movie/where-the-dead-go-to-die': 'group1',
	'/us/movie/x-rated-the-greatest-adult-movies-of-all-time': 'group1',
	'/us/movie/les-miserables': 'group1',
	'/us/movie/sleeping-with-my-student': 'group1',
	'/us/movie/heavens-rain': 'group1',
	'/us/movie/the-electric-state': 'group1',
	'/us/movie/hot-fuzz': 'group1',
	'/us/movie/devil-down-south': 'group1',
	'/us/movie/hallow-road': 'group1',
	'/us/movie/french-kiss': 'group1',
	'/us/movie/e-t-the-extra-terrestrial': 'group1',
	'/us/movie/the-last-rodeo': 'group1',
	'/us/movie/tin-cup': 'group1',
	'/us/movie/amadeus': 'group1',
	'/us/movie/the-crow': 'group1',
	'/us/movie/together-2025': 'group1',
	'/us/movie/le-dernier-invite': 'group1',
	'/us/movie/the-mask': 'group1',
	'/us/movie/the-room-next-door': 'group1',
	'/us/movie/apocalypse-now-redux': 'group1',
	'/us/movie/green-book': 'group1',
	'/us/movie/guns-and-moses': 'group1',
	'/us/movie/dawn-anna': 'group1',
	'/us/movie/are-you-there-god-its-me-margaret': 'group1',
	'/us/movie/the-best-two-years': 'group1',
	'/au/movie/lilim': 'group2',
	'/au/movie/marked-men-rule-and-shaw': 'group2',
	'/au/movie/mon-potongo': 'group2',
	'/au/movie/conclave': 'group2',
	'/au/movie/erotic-ghost-story-ii': 'group2',
	'/au/movie/mehsampur': 'group2',
	'/au/movie/neer-paravai': 'group2',
	'/au/movie/antony-and-cleopatra': 'group2',
	'/au/movie/magazine-dreams': 'group2',
	'/au/movie/the-return-2024': 'group2',
	'/au/movie/snow-white-and-the-seven-dwarfs-2022': 'group2',
	'/au/movie/runt-2024-0': 'group2',
	'/au/movie/love-and-sex-in-russia': 'group2',
	'/uk/movie/thirteen': 'group2',
	'/uk/movie/conclave': 'group2',
	'/uk/movie/grimsby': 'group2',
	'/uk/movie/paddington-in-peru': 'group2',
	'/uk/movie/better-man': 'group2',
	'/uk/movie/on-falling': 'group2',
	'/uk/movie/ask-sadece-bir-an': 'group2',
	'/uk/movie/dungeons-and-dragons': 'group2',
	'/uk/movie/chaava': 'group2',
	'/uk/movie/september-5': 'group2',
	'/uk/movie/national-theatre-live-dr-strangelove': 'group2',
	'/uk/movie/andre': 'group2',
	'/uk/movie/wildflower-2023': 'group2',
	'/uk/movie/prithviraj': 'group2',
	'/uk/movie/fast-and-furious-9': 'group2',
	'/uk/movie/fast-and-furious': 'group2',
	'/uk/movie/juste-ciel': 'group2',
	'/uk/movie/despicable-me-4': 'group2',
	'/uk/movie/ghost-rite-here-rite-now': 'group2',
	'/uk/movie/as-the-gods-will': 'group2',
	'/uk/movie/rani-2025': 'group2',
	'/uk/movie/the-raid': 'group2',
	'/uk/movie/essex-boys': 'group2',
	'/us/movie/levons-trade': 'group2',
	'/us/movie/spermageddon': 'group2',
	'/us/movie/young-frankenstein': 'group2',
	'/us/movie/distant-2022': 'group2',
	'/us/movie/kiss-and-kill': 'group2',
	'/us/movie/the-gorge': 'group2',
	'/us/movie/happy-gilmore': 'group2',
	'/us/movie/eddie-and-the-cruisers': 'group2',
	'/us/movie/six-the-musical-live': 'group2',
	'/us/movie/the-goonies': 'group2',
	'/us/movie/the-burbs': 'group2',
	'/us/movie/twisters': 'group2',
	'/us/movie/the-last-american-virgin': 'group2',
	'/us/movie/friendship-2024': 'group2',
	'/us/movie/se7en': 'group2',
	'/us/movie/oceans-eleven': 'group2',
	'/us/movie/im-still-here-2025': 'group2',
	'/us/movie/pushpa-the-rule-part-2': 'group2',
	'/us/movie/going-the-distance-2004': 'group2',
	'/us/movie/the-neverending-story': 'group2',
	'/us/movie/the-meteor-man': 'group2',
	'/us/movie/the-way-we-were': 'group2',
	'/us/movie/daily-motion': 'group2',
	'/us/movie/spice-world': 'group2',
	'/us/movie/being-maria': 'group2',
	'/us/movie/mon-potongo': 'group2',
	'/us/movie/v-for-vendetta': 'group2',
	'/us/movie/teenage-mutant-ninja-turtles': 'group2',
	'/us/movie/harold-and-kumar-go-to-white-castle': 'group2',
	'/us/movie/the-drop-2014': 'group2',
	'/us/movie/coraline': 'group2',
	'/us/movie/the-mummy-1999': 'group2',
	'/us/movie/escape-from-pleasure-planet': 'group2',
	'/us/movie/same-time-next-year': 'group2',
	'/us/movie/les-gangs-de-new-york': 'group2',
	'/us/movie/near-dark': 'group2',
	'/us/movie/le-punisher-les-liens-du-sang': 'group2',
	'/us/movie/sarangi-a-journey-of-purna-bahadur': 'group2',
	'/us/movie/the-da-vinci-code-1': 'group2',
	'/us/movie/a-chinese-ghost-story-ii': 'group2',
	'/us/movie/the-big-lebowski': 'group2',
	'/au/movie/flow-2024': 'group3',
	'/au/movie/mrs': 'group3',
	'/au/movie/aroused': 'group3',
	'/au/movie/nezha-mo-tong-nao-hai': 'group3',
	'/au/movie/a-serbian-film': 'group3',
	'/au/movie/friendship-2024': 'group3',
	'/au/movie/the-monkey': 'group3',
	'/au/movie/paddington-in-peru': 'group3',
	'/au/movie/the-man-from-snowy-river': 'group3',
	'/au/movie/let-her-cry': 'group3',
	'/au/movie/cold-feet-2018': 'group3',
	'/au/movie/illegal-1955': 'group3',
	'/au/movie/rust': 'group3',
	'/au/movie/most-eligible-bachelor': 'group3',
	'/au/movie/dil-to-pagal-hai': 'group3',
	'/uk/movie/pideme-lo-que-quieras': 'group3',
	'/uk/movie/babygirl-2024': 'group3',
	'/uk/movie/ne-zha': 'group3',
	'/uk/movie/heretic-2024': 'group3',
	'/uk/movie/twilight': 'group3',
	'/uk/movie/locked': 'group3',
	'/uk/movie/four-mothers': 'group3',
	'/uk/movie/the-legend-of-maula-jatt': 'group3',
	'/uk/movie/mufasa-the-lion-king': 'group3',
	'/uk/movie/twisters': 'group3',
	'/uk/movie/fifty-shades-of-grey': 'group3',
	'/uk/movie/hans-zimmer-and-friends-diamond-in-the-desert': 'group3',
	'/uk/movie/interstellar': 'group3',
	'/uk/movie/companion-2025': 'group3',
	'/uk/movie/englands-lions-the-new-generation': 'group3',
	'/uk/movie/the-inbetweeners-movie': 'group3',
	'/uk/movie/hoodwinked': 'group3',
	'/uk/movie/city-of-god': 'group3',
	'/uk/movie/willy-wonka-and-the-chocolate-factory': 'group3',
	'/uk/movie/girl-in-the-basement': 'group3',
	'/uk/movie/blue-is-the-warmest-color': 'group3',
	'/uk/movie/vulgar': 'group3',
	'/uk/movie/boiling-point-2021': 'group3',
	'/uk/movie/the-equalizer-3': 'group3',
	'/uk/movie/runt-2024-0': 'group3',
	'/uk/movie/aashiqui-2': 'group3',
	'/us/movie/riff-raff-2024': 'group3',
	'/us/movie/my-hero-academia-the-movie-youre-next': 'group3',
	'/us/movie/the-assessment': 'group3',
	'/us/movie/let-me-eat-your-pancreas': 'group3',
	'/us/movie/salo-or-the-120-days-of-sodom': 'group3',
	'/us/movie/selena-y-los-dinos': 'group3',
	'/us/movie/wolf-of-wall-street-the': 'group3',
	'/us/movie/the-sleeping-dictionary': 'group3',
	'/us/movie/ready-player-one': 'group3',
	'/us/movie/flight-risk-2024': 'group3',
	'/us/movie/a-tale-of-legendary-libido': 'group3',
	'/us/movie/rule-breakers': 'group3',
	'/us/movie/hidden-figures': 'group3',
	'/us/movie/le-comte-de-monte-cristo': 'group3',
	'/us/movie/the-hunger-games-catching-fire': 'group3',
	'/us/movie/now-you-see-me': 'group3',
	'/us/movie/a-few-good-men': 'group3',
	'/us/movie/casino-royale-uncut-edition': 'group3',
	'/us/movie/the-monkey-king-3': 'group3',
	'/us/movie/taboo-family-secrets': 'group3',
	'/us/movie/thing-the': 'group3',
	'/us/movie/charm-city-kings': 'group3',
	'/us/movie/on-swift-horses': 'group3',
	'/us/movie/super-mario-bros': 'group3',
	'/us/movie/a-cinderella-story-two': 'group3',
	'/us/movie/classroom-6': 'group3',
	'/us/movie/paddington': 'group3',
	'/us/movie/borderlands-2024': 'group3',
	'/us/movie/tropic-thunder': 'group3',
	'/us/movie/small-things-like-these': 'group3',
	'/us/movie/reagan-2023': 'group3',
	'/us/movie/erotic-ghost-story': 'group3',
	'/us/movie/the-twister-caught-in-the-storm': 'group3',
	'/us/movie/the-passion-of-the-christ': 'group3',
	'/us/movie/winter-spring-summer-or-fall': 'group3',
	'/us/movie/pump-up-the-volume': 'group3',
	'/au/movie/marching-powder-2025': 'group4',
	'/au/movie/sex-party-and-lies': 'group4',
	'/au/movie/the-woman-in-the-yard': 'group4',
	'/au/movie/le-comte-de-monte-cristo': 'group4',
	'/au/movie/nilavuku-en-mel-ennadi-kobam': 'group4',
	'/au/movie/captain-america-new-world-order': 'group4',
	'/au/movie/the-hunger-games-the-ballad-of-songbirds-and-snakes': 'group4',
	'/au/movie/bareilly-ki-barfi': 'group4',
	'/au/movie/the-wild-robot': 'group4',
	'/au/movie/the-slingshot': 'group4',
	'/au/movie/spermageddon': 'group4',
	'/au/movie/concrete': 'group4',
	'/uk/movie/the-eye-2023': 'group4',
	'/uk/movie/black-bag-2025': 'group4',
	'/uk/movie/irada': 'group4',
	'/uk/movie/a-bronx-tale': 'group4',
	'/uk/movie/the-ballad-of-wallis-island': 'group4',
	'/uk/movie/dune-2020': 'group4',
	'/uk/movie/the-woman-in-the-yard': 'group4',
	'/uk/movie/snow-white-and-the-seven-dwarfs-2019': 'group4',
	'/uk/movie/macbeth-david-tennant-and-cush-jumbo': 'group4',
	'/uk/movie/the-truman-show': 'group4',
	'/uk/movie/john-wick': 'group4',
	'/uk/movie/the-hunger-games-the-ballad-of-songbirds-and-snakes': 'group4',
	'/uk/movie/deiva-thirumagal': 'group4',
	'/uk/movie/intimate-relations': 'group4',
	'/uk/movie/amelie': 'group4',
	'/uk/movie/american-pie': 'group4',
	'/uk/movie/riff-raff-2024': 'group4',
	'/uk/movie/becoming-led-zeppelin': 'group4',
	'/uk/movie/3096-days': 'group4',
	'/uk/movie/national-theatre-live-the-importance-of-being-earnest': 'group4',
	'/uk/movie/bittu': 'group4',
	'/uk/movie/the-sinking-of-the-lisbon-maru': 'group4',
	'/uk/movie/apne': 'group4',
	'/uk/movie/the-lovely-bones': 'group4',
	'/uk/movie/young-frankenstein': 'group4',
	'/uk/movie/santhu-straight-forward': 'group4',
	'/uk/movie/pirates-of-the-caribbean-the-curse-of-the-black-pearl': 'group4',
	'/uk/movie/the-basketball-diaries': 'group4',
	'/us/movie/overlord-sei-oukoku-hen': 'group4',
	'/us/movie/audreys-children': 'group4',
	'/us/movie/the-matrix': 'group4',
	'/us/movie/drop-2025': 'group4',
	'/us/movie/babygirl-2024': 'group4',
	'/us/movie/apache-2023': 'group4',
	'/us/movie/the-hunger-games-the-ballad-of-songbirds-and-snakes': 'group4',
	'/us/movie/cold-feet-2018': 'group4',
	'/us/movie/moneyball': 'group4',
	'/us/movie/the-legend-of-maula-jatt': 'group4',
	'/us/movie/the-bourne-identity': 'group4',
	'/us/movie/colorful-stage-the-movie-a-miku-who-cant-sing': 'group4',
	'/us/movie/it-boy': 'group4',
	'/us/movie/this-is-spinal-tap': 'group4',
	'/us/movie/vampire-hunter-d': 'group4',
	'/us/movie/scary-movie': 'group4',
	'/us/movie/the-legend-of-the-condor-heroes-the-great-hero': 'group4',
	'/us/movie/vulgar': 'group4',
	'/us/movie/step-brothers': 'group4',
	'/us/movie/how-to-train-your-dragon-the-hidden-world': 'group4',
	'/us/movie/lets-go-to-prison': 'group4',
	'/us/movie/sonic-the-hedgehog-3': 'group4',
	'/us/movie/1-2-3-all-eyes-on-me': 'group4',
	'/us/movie/get-out': 'group4',
	'/us/movie/terror-on-the-prairie': 'group4',
	'/us/movie/the-gangster-the-cop-the-devil': 'group4',
	'/us/movie/the-big-short': 'group4',
	'/us/movie/ladder-49': 'group4',
	'/us/movie/strannyy-dom': 'group4',
	'/us/movie/renaissance-a-film-by-beyonce': 'group4',
	'/us/movie/hes-just-not-that-into-you': 'group4',
	'/us/movie/arrival-2016': 'group4',
	'/us/movie/april-29-1992': 'group4',
	'/us/movie/jai-gangaajal': 'group4',
	'/us/movie/kingsman-the-golden-circle': 'group4',
	'/us/movie/and-the-breadwinner-is': 'group4',
	'/us/movie/dogtooth': 'group4',
	'/us/movie/lord-of-the-rings-i-the-fellowship-of-the-ring': 'group4',
	'/us/movie/no-country-for-old-men': 'group4',
	'/us/movie/the-last-samurai': 'group4',
	'/au/movie/the-skin-i-live-in': 'group5',
	'/au/movie/mickey-17': 'group5',
	'/au/movie/wicked-2021': 'group5',
	'/au/movie/manje-bistre-2': 'group5',
	'/au/movie/twisters': 'group5',
	'/au/movie/ange-and-the-boss-puskas-in-australia': 'group5',
	'/au/movie/student-services': 'group5',
	'/au/movie/sonic-the-hedgehog-3': 'group5',
	'/au/movie/do-dooni-chaar': 'group5',
	'/au/movie/in-the-lost-lands': 'group5',
	'/au/movie/mufasa-the-lion-king': 'group5',
	'/au/movie/double-barrel-2017': 'group5',
	'/uk/movie/mittran-da-chaleya-truck-ni': 'group5',
	'/uk/movie/this-is-england': 'group5',
	'/uk/movie/charm-city-kings': 'group5',
	'/uk/movie/the-lord-of-the-rings-the-fellowship-of-the-ring': 'group5',
	'/uk/movie/amateur-2024': 'group5',
	'/uk/movie/salo-or-the-120-days-of-sodom': 'group5',
	'/uk/movie/my-hero-academia-the-movie-youre-next': 'group5',
	'/uk/movie/sister-midnight': 'group5',
	'/uk/movie/crocodile-dundee': 'group5',
	'/uk/movie/last-breath-2024': 'group5',
	'/uk/movie/bridget-joness-diary': 'group5',
	'/uk/movie/desire-2011': 'group5',
	'/uk/movie/dune-part-two': 'group5',
	'/uk/movie/the-notebook': 'group5',
	'/uk/movie/chal-mera-putt-3': 'group5',
	'/uk/movie/venom-3-2024': 'group5',
	'/uk/movie/the-beekeeper-2024': 'group5',
	'/uk/movie/borderline-2025': 'group5',
	'/uk/movie/transformers-one-2024': 'group5',
	'/uk/movie/the-lord-of-the-rings-the-fellowship-of-the-ring-extended-edition-2002': 'group5',
	'/uk/movie/nosferatu-2023': 'group5',
	'/uk/movie/the-unlikely-pilgrimage-of-harold-fry': 'group5',
	'/uk/movie/april-29-1992': 'group5',
	'/us/movie/black-bag': 'group5',
	'/us/movie/homestead-2024': 'group5',
	'/us/movie/the-basketball-diaries': 'group5',
	'/us/movie/car-dogs': 'group5',
	'/us/movie/companion-2025': 'group5',
	'/us/movie/best-in-show': 'group5',
	'/us/movie/tina-2025': 'group5',
	'/us/movie/heavenly-creatures': 'group5',
	'/us/movie/the-substance': 'group5',
	'/us/movie/john-wick': 'group5',
	'/us/movie/untitled-buddy-comedy-tristar-pictures': 'group5',
	'/us/movie/below-her-mouth': 'group5',
	'/us/movie/fifty-shades-of-grey': 'group5',
	'/us/movie/my-love-will-make-you-disappear': 'group5',
	'/us/movie/dumb-and-dumber': 'group5',
	'/us/movie/raising-helen': 'group5',
	'/us/movie/crimson-tide': 'group5',
	'/us/movie/spider-man-no-way-home': 'group5',
	'/us/movie/young-sister-in-law': 'group5',
	'/us/movie/strange-days': 'group5',
	'/us/movie/heretic-2024': 'group5',
	'/us/movie/rape-zombie-lust-of-the-dead': 'group5',
	'/us/movie/attack-on-titan-the-movie-the-last-attack': 'group5',
	'/us/movie/in-your-eyes': 'group5',
	'/us/movie/ask-sadece-bir-an': 'group5',
	'/us/movie/celebrity-sex-tape': 'group5',
	'/us/movie/mannequin-1987': 'group5',
	'/us/movie/werewolves': 'group5',
	'/us/movie/seven-veils': 'group5',
	'/us/movie/chaava': 'group5',
	'/us/movie/the-maze-runner': 'group5',
	'/us/movie/kingdom-of-heaven-directors-cut': 'group5',
	'/us/movie/superbad': 'group5',
	'/us/movie/tornado-alley': 'group5',
	'/us/movie/cracks': 'group5',
	'/us/movie/terrifier-3': 'group5',
	'/us/movie/six-triple-eight': 'group5',
	'/us/movie/tremors': 'group5',
	'/us/movie/a-lot-like-love': 'group5',
	'/us/movie/a-time-to-kill': 'group5',
	'/us/movie/zoolander': 'group5',
};

const tvshows: Record<string, MetaGroups> = {
	'/uk/tv-series/invincible': 'group1',
	'/uk/tv-series/phoenix-nights': 'group1',
	'/uk/tv-series/the-handmaids-tale': 'group1',
	'/uk/tv-series/the-last-of-us': 'group1',
	'/uk/tv-series/suits-la': 'group1',
	'/uk/tv-series/the-sopranos': 'group1',
	'/uk/tv-series/tacoma-fd': 'group1',
	'/uk/tv-series/rupauls-drag-race': 'group1',
	'/uk/tv-series/sex-and-the-city': 'group1',
	'/uk/tv-series/rome': 'group1',
	'/uk/tv-series/alert-missing-persons-unit': 'group1',
	'/uk/tv-series/lol-last-one-laughing': 'group1',
	'/uk/tv-series/naruto': 'group1',
	'/uk/tv-series/the-secret-life-of-4-5-and-6-year-olds': 'group1',
	'/uk/tv-series/drop-dead-diva': 'group1',
	'/uk/tv-series/australian-survivor': 'group1',
	'/uk/tv-series/grosse-pointe-garden-society': 'group1',
	'/uk/tv-series/rise-of-the-raven': 'group1',
	'/us/tv-show/one-piece': 'group1',
	'/us/tv-show/the-day-of-the-jackal': 'group1',
	'/us/tv-show/wwe-raw': 'group1',
	'/us/tv-show/haisukurudxd': 'group1',
	'/us/tv-show/ben-10-ultimate-alien': 'group1',
	'/us/tv-show/suits-la': 'group1',
	'/us/tv-show/6666': 'group1',
	'/us/tv-show/the-eminence-in-shadow': 'group1',
	'/us/tv-show/survivor': 'group1',
	'/au/tv-show/the-rookie': 'group2',
	'/au/tv-show/australian-idol': 'group2',
	'/uk/tv-series/the-rookie': 'group2',
	'/uk/tv-series/parks-and-recreation': 'group2',
	'/uk/tv-series/married-at-first-sight-2015': 'group2',
	'/uk/tv-series/euphoria': 'group2',
	'/uk/tv-series/shooting-stars': 'group2',
	'/uk/tv-series/pen15': 'group2',
	'/uk/tv-series/greys-anatomy': 'group2',
	'/uk/tv-series/south-park': 'group2',
	'/uk/tv-series/the-expanse': 'group2',
	'/uk/tv-series/the-curious-case-of-natalia-grace': 'group2',
	'/uk/tv-series/top-boy': 'group2',
	'/uk/tv-series/power-book-iii-raising-kanan': 'group2',
	'/uk/tv-series/attack-on-titan': 'group2',
	'/uk/tv-series/upcoming': 'group2',
	'/us/tv-show/euphoria': 'group2',
	'/us/tv-show/fire-in-his-fingertips': 'group2',
	'/us/tv-show/common-side-effects': 'group2',
	'/us/tv-show/fallen-2024': 'group2',
	'/us/tv-show/tyler-perrys-if-loving-you-is-wrong': 'group2',
	'/us/tv-show/friday-night-lights': 'group2',
	'/us/tv-show/jenni-rivera-mariposa-de-barrio': 'group2',
	'/us/tv-show/wwe-smackdown': 'group2',
	'/us/tv-show/happy-kanakos-killer-life': 'group2',
	'/us/tv-show/yellowstone-2018': 'group2',
	'/us/tv-show/seven-mortal-sins': 'group2',
	'/us/tv-show/my-teen-romantic-comedy-snafu-2013': 'group2',
	'/uk/tv-series/the-white-lotus': 'group3',
	'/uk/tv-series/severance': 'group3',
	'/uk/tv-series/daredevil-born-again': 'group3',
	'/uk/tv-series/fallen': 'group3',
	'/uk/tv-series/monk': 'group3',
	'/uk/tv-series/9-1-1': 'group3',
	'/uk/tv-series/solo-leveling': 'group3',
	'/uk/tv-series/teen-wolf': 'group3',
	'/uk/tv-series/jack-reacher': 'group3',
	'/uk/tv-series/a-league-of-their-own': 'group3',
	'/uk/tv-series/hip-high-intellectual-potential': 'group3',
	'/us/tv-show/win-or-lose': 'group3',
	'/us/tv-show/adolescence-2025': 'group3',
	'/us/tv-show/wentworth': 'group3',
	'/us/tv-show/the-white-lotus': 'group3',
	'/us/tv-show/interspecies-reviewers': 'group3',
	'/us/tv-show/las-hijas-de-la-senora-garcia': 'group3',
	'/us/tv-show/redo-of-healer': 'group3',
	'/us/tv-show/serial-experiments-lain': 'group3',
	'/us/tv-show/law-and-order-special-victims-unit': 'group3',
	'/us/tv-show/f4-thailand-boys-over-flowers': 'group3',
	'/us/tv-show/everything-for-demon-king-evelogia': 'group3',
	'/us/tv-show/dope-thief': 'group3',
	'/us/tv-show/why-the-hell-are-you-here-teacher': 'group3',
	'/us/tv-show/m-son-of-the-century': 'group3',
	'/us/tv-show/outer-banks': 'group3',
	'/us/tv-show/malibu-surf': 'group3',
	'/us/tv-show/the-replacement': 'group3',
	'/au/tv-show/four-years-later': 'group4',
	'/au/tv-show/solo-leveling': 'group4',
	'/uk/tv-series/come-fly-with-me': 'group4',
	'/uk/tv-series/ludwig': 'group4',
	'/uk/tv-series/the-day-of-the-jackal': 'group4',
	'/uk/tv-series/meet-the-rees-moggs': 'group4',
	'/uk/tv-series/ted-lasso': 'group4',
	'/uk/tv-series/bairi-piya': 'group4',
	'/uk/tv-series/house-of-david': 'group4',
	'/uk/tv-series/nirvanna-the-band-the-show': 'group4',
	'/uk/tv-series/vikings': 'group4',
	'/us/tv-show/daredevil-born-again': 'group4',
	'/us/tv-show/utha-patak': 'group4',
	'/us/tv-show/rupauls-drag-race': 'group4',
	'/us/tv-show/yosuganosora': 'group4',
	'/us/tv-show/naruto-shippuden': 'group4',
	'/us/tv-show/house-of-david': 'group4',
	'/us/tv-show/between-the-lions': 'group4',
	'/us/tv-show/jack-reacher': 'group4',
	'/us/tv-show/vermeil-in-gold': 'group4',
	'/us/tv-show/la-venganza-de-los-ex-vip': 'group4',
	'/us/tv-show/blood-c': 'group4',
	'/us/tv-show/mystery-diners': 'group4',
	'/us/tv-show/sweet-trap': 'group4',
	'/au/tv-show/married-at-first-sight-australia': 'group5',
	'/au/tv-show/lol-last-one-laughing-uk': 'group5',
	'/uk/tv-series/the-take': 'group5',
	'/uk/tv-series/law-and-order-special-victims-unit': 'group5',
	'/uk/tv-series/dating-naked': 'group5',
	'/uk/tv-series/adolescence': 'group5',
	'/uk/tv-series/evil': 'group5',
	'/uk/tv-series/tempting-fortune': 'group5',
	'/uk/tv-series/1923': 'group5',
	'/uk/tv-series/the-jeremy-kyle-show': 'group5',
	'/uk/tv-series/naked-attraction': 'group5',
	'/uk/tv-series/happy-face': 'group5',
	'/uk/tv-series/home-and-away': 'group5',
	'/uk/tv-series/24-hours-in-police-custody': 'group5',
	'/uk/tv-series/reign': 'group5',
	'/us/tv-show/study-group': 'group5',
	'/us/tv-show/super-dragon-ball-heroes': 'group5',
	'/us/tv-show/everyday-life-with-monster-girls': 'group5',
	'/us/tv-show/the-qwaser-of-stigmata': 'group5',
	'/us/tv-show/dragon-booster': 'group5',
	'/us/tv-show/nurse-jackie': 'group5',
	'/us/tv-show/curvy-girls': 'group5',
	'/us/tv-show/the-walking-dead': 'group5',
	'/us/tv-show/fisica-o-quimica-la-nueva-generacion': 'group5',
	'/us/tv-show/adams-sweet-agony': 'group5',
	'/us/tv-show/snowfall': 'group5',
};

export const ctrExperimentUrlsMap = { movies, tvshows };

const illegalMetaRules = {
	movies: {
		group1: {
			lessThan13:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video · Disney+ - inc. Free & 4K options!',
			lessThan22:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video · Disney+ - inc. Free & 4K options!',
			lessThan33:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video - inc. Free & 4K options!',
			lessThan53:
				'Find out where to watch {title} on streaming services such as Netflix · Prime Video inc. Free & 4K options!',
			default: 'Watch {title} on streaming services such as Netflix · Prime Video inc. Free & 4K options!',
		},
		group2: {
			lessThan13:
				'Watch {title} · Full movie online · On streaming services such as Netflix, Prime Video & Disney+ - inc. ✓ Free & ✓ 4K options!',
			lessThan22:
				'Watch {title} · Full movie online · On streaming services such as Netflix, Prime Video & Disney+ – inc. ✓ Free & ✓ 4K options!',
			lessThan33:
				'Watch {title} · Full movie online · On streaming services such as Netflix, Prime Video & Disney+ – inc. ✓ Free & ✓ 4K options!',
			lessThan53:
				'Watch {title} · Full movie · On streaming services such as Netflix, Prime Video inc. ✓ Free & ✓ 4K options!',
			default: 'Watch {title} · Full movie · On streaming services such as Netflix ✓ Free & ✓ 4K options!',
		},
		group3: {
			lessThan13:
				'Watch {title} · Full movie online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan22:
				'Watch {title} · Full movie online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan33:
				'Watch {title} · Full movie online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan53:
				'Watch {title} · Full movie for free · On streaming services such as Netflix, Prime Video – inc. 4K options!',
			default: 'Watch {title} · Full movie for free · On streaming services such as Netflix inc. 4K options!',
		},
		group4: {
			lessThan13:
				'Watch {title} online ✓ Full movie ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan22:
				'Watch {title} online ✓ Full movie ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan33:
				'Watch {title} online ✓ Full movie ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan53:
				'Watch {title} online ✓ Full movie ✓ Free & 4K options! On streaming services such as Netflix, Prime Video.',
			default: 'Watch {title} online ✓ Full movie ✓ Free & 4K options! On streaming services such as Netflix.',
		},
		group5: {
			lessThan13:
				'Watch {title} · Full movie online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan22:
				'Watch {title} · Full movie online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan33:
				'Watch {title} · Full movie online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan53:
				'Watch {title} · Full movie online · Free & 4K options · On streaming services such as Netflix & Prime Video.',
			default: 'Watch {title} · Full movie · Free & 4K options · On streaming services such as Netflix.',
		},
	},
	tvshows: {
		group1: {
			lessThan13:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video · Disney+ – inc. Free & 4K options!',
			lessThan22:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video · Disney+ – inc. Free & 4K options!',
			lessThan33:
				'Find out how and where to watch {title} online on streaming services such as Netflix · Prime Video – inc. Free & 4K options!',
			lessThan53:
				'Find out where to watch {title} on streaming services such as Netflix · Prime Video inc. Free & 4K options!',
			default: 'Watch {title} on streaming services such as Netflix · Prime Video inc. Free & 4K options!',
		},
		group2: {
			lessThan13:
				'Watch {title} · All Episodes online · On streaming services such as Netflix, Prime Video & Disney+ – inc. ✓ Free & ✓ 4K options!',
			lessThan22:
				'Watch {title} · All Episodes online · On streaming services such as Netflix, Prime Video & Disney+ – inc. ✓ Free & ✓ 4K options!',
			lessThan33:
				'Watch {title} · All Episodes online · On streaming services such as Netflix, Prime Video & Disney+ – inc. ✓ Free & ✓ 4K options!',
			lessThan53:
				'Watch {title} · All Episodes · On streaming services such as Netflix, Prime Video inc. ✓ Free & ✓ 4K options!',
			default: 'Watch {title} · All Episodes · On streaming services such as Netflix ✓ Free & ✓ 4K options!',
		},
		group3: {
			lessThan13:
				'Watch {title} · All Episodes online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan22:
				'Watch {title} · All Episodes online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan33:
				'Watch {title} · All Episodes online for free · On streaming services such as Netflix, Prime Video & Disney+ – inc. 4K options!',
			lessThan53:
				'Watch {title} · All Episodes for free · On streaming services such as Netflix, Prime Video – inc. 4K options!',
			default: 'Watch {title} · All Episodes for free · On streaming services such as Netflix inc. 4K options!',
		},
		group4: {
			lessThan13:
				'Watch {title} online ✓ All Episodes ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan22:
				'Watch {title} online ✓ All Episodes ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan33:
				'Watch {title} online ✓ All Episodes ✓ Free & 4K options! On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan53:
				'Watch {title} online ✓ All Episodes ✓ Free & 4K options! On streaming services such as Netflix, Prime Video.',
			default: 'Watch {title} online ✓ All Episodes ✓ Free & 4K options! On streaming services such as Netflix.',
		},
		group5: {
			lessThan13:
				'Watch {title} · All Episodes online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan22:
				'Watch {title} · All Episodes online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan33:
				'Watch {title} · All Episodes online · Free & 4K options · On streaming services such as Netflix, Prime Video & Disney+.',
			lessThan53:
				'Watch {title} · All Episodes online · Free & 4K options · On streaming services such as Netflix & Prime Video.',
			default: 'Watch {title} · All Episodes · Free & 4K options · On streaming services such as Netflix.',
		},
	},
};

const countries = ['AU', 'GB', 'US'] as const;

export function getCTRExperimentMetaDescription(title: string, isMovie: boolean, url: string) {
	const category = isMovie ? 'movies' : 'tvshows';
	const group = ctrExperimentUrlsMap[category][url];
	if (!group) return null;
	return illegalMetaRules[category][group][getTitleLength(title)].replace('{title}', title);
}

function getTitleLength(title: string) {
	if (title.length < 13) return 'lessThan13';
	if (title.length < 22) return 'lessThan22';
	if (title.length < 33) return 'lessThan33';
	if (title.length < 53) return 'lessThan53';
	return 'default';
}

export function isCTRExperimentCountry(country: string): country is 'AU' | 'GB' | 'US' {
	return countries.includes(country as any);
}
